export const PLAN_LABEL_FREE = 'Free';
export const PLAN_LABEL_PRO = 'Pro';
export const PLAN_LABEL_COMPANY = 'Company';
export const PLAN_LABEL_TEAM = 'Team';
export const PLAN_LABEL_ENTERPRISE = 'Enterprise';



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/constants/plans/labels.js